module.exports = __webpack_public_path__ + "static/img/bird.a4fc67f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/bird.png
// module id = tY7X
// module chunks = 0